module.exports = __webpack_public_path__ + "assets/202509252035/img/Lawliet.f48b49d0.jpg";